export const barChart = (height = "auto", legends, xAxis, series, format, current_year, past_year) => {
    const format_value = format === "room_night" ? '{value}' : '${value}';
    let current_year_aux = new Number(current_year);
    let selected_legends = {};
    legends.forEach(element => {
        let past = new Number(element);
        if(current_year_aux > past){
            selected_legends[past.toString()] = false;
        }
    });
    return {
        title: {
            text: "",
            subtext: ""
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow"
            }
        },
        legend: {
            data: legends,
            orient: "vertical",
            right: "15px",
            top:   "25px",
            width: "80px",
            selected : selected_legends
        },
        grid: {
            left: "15px",
            right: "100px",
            top:   "25px",
            bottom : "15px",
            height: height,
            containLabel: true
        },
        yAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
            axisLabel : {
                formatter : format_value
            },

        },
        xAxis: {
            type: "category",
            data: xAxis
        },
        series: series
    }
}
export const scatterChart = (result, format) => {
    const format_value = format === "room_night" ? '{value}' : '${value}';
    return {
        xAxis: {
            min : 1,
            scale: true
        },
        yAxis: {
            type : "value",
            scale: true,
            axisLabel : {
                formatter : format_value
            },
        },
        grid: {
            left: "15px",
            right: "15px",
            top:   "25px",
            bottom : "15px",
            containLabel: true
        },
        series: [
            {
                type: 'effectScatter',
                symbolSize: 10,
                data:  result !== undefined ? result["max_min_serie"] : [],
                label: {
                    emphasis: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: 'white',
                            fontSize: 16,
                            backgroundColor:"transparent",
                            textBorderWidth : 3,
                            textBorderColor : "#000000"
                        }
                    }
                } 
            },{
                symbolSize: 6,
                color: "#000",
                type: 'scatter',
                data: result !== undefined ? result["series"] : [],
                
            }
        ]
    };
}


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/widgets/Charts.js